import React  from "react";

import Filtration from "./Filtration";



const Sidebar = () => {



  return (
    <>
      <Filtration />
    
    </>
    );
};

export default Sidebar;
